import React, { FC } from 'react'
import { ComponentBio } from '../../../models/components/bio'
import SpeakerBio from './speakerBio'
import { SpeakerListContainer } from './style'

type Props = {
  data: ComponentBio[]
  topicItemListUseCase: string
}

const SpeakerList: FC<Props> = ({ data, topicItemListUseCase }) => {
  return (
    <SpeakerListContainer $speakerCount={data.length}>
      <div className="SpeakerList">
        {data.map((speaker: any, index: number) => {
          const leadershipBioData = { ...speaker }
          return (
            <React.Fragment key={speaker?.id}>
              {speaker.__typename === 'ContentfulComponentBio' && (
                <SpeakerBio
                  key={`speakerBio_${index}`}
                  {...leadershipBioData}
                  topicItemListUseCase={topicItemListUseCase}
                />
              )}
            </React.Fragment>
          )
        })}
      </div>
    </SpeakerListContainer>
  )
}

export default SpeakerList
